// NOTE FROM ORIGINAL FILE slider.js:
// ! Uncompiled https://github.com/loryjs/lory lory.js line 587 reset() commented out to fix library issues delt with for ticket NCC-640. Do not confuse with the file in vendor/lory which is compilied but not uglified.

//------ TESTIMONIAL SLIDER STARTS ------//

jQuery(function(){ //equivalent of ready in jQ 3.0

    function handleTestimonialDotEvent(e) {
        var $container = jQuery(e.target);
        var $nav = $container.find('.testimonial-slider__navigation');
        var current_slide = e.detail.currentSlide - 1;
        var $active_dot = $nav.find('.testimonial-slider__dot:eq('+ current_slide +')');

        jQuery('.testimonial-slider__dot').removeClass('testimonial-slider__dot--active');
        $active_dot.addClass('testimonial-slider__dot--active');
    }

    function testimonialSliderAriaHidden() {
        for (var index = 0; index < testimonialSlides.length; index++) {
            var testimonialslide_aria_hidden = testimonialSlides[index];

            if (testimonialslide_aria_hidden.classList.contains('active')) {
                testimonialslide_aria_hidden.setAttribute("aria-hidden", "false");
                testimonialslide_aria_hidden.querySelector(".testimonial-slider__slide-content").setAttribute("aria-hidden", "false");
                testimonialslide_aria_hidden.setAttribute("tabindex", "0");
            } else {
                testimonialslide_aria_hidden.setAttribute("aria-hidden", "true");
                testimonialslide_aria_hidden.querySelector(".testimonial-slider__slide-content").setAttribute("aria-hidden", "true");
                testimonialslide_aria_hidden.setAttribute("tabindex", "-1");
            }
        }
    }

    function testimonialSliderAriaSelectedDots() {
        for (var index = 0; index < testimonialSlidesDots.length; index++) {
            var element = testimonialSlidesDots[index];

            if (element.classList.contains('testimonial-slider__dot--active')) {
                element.setAttribute("aria-selected", "true");
            } else {
                element.setAttribute("aria-selected", "false");
            }
        }
    }

    function initializeTestimonialSlider() {
        // console.log("TESTIMONIAL slider initialized!");

        jQuery('.testimonial-slider__container').each(function(index, ele){
            var interval = 7000;
            var $s = jQuery(this);

            if(jQuery(this).attr('data-interval')) {
                interval = parseInt(jQuery(this).data('interval')) * 1000;
            }


            var testimonialSlider = lory(ele, {
                infinite: 1,
                slideSpeed: 500,
                classNameFrame: 'testimonial-slider__frame',
                classNameSlideContainer: 'testimonial-slider__slides',
                classNamePrevCtrl: 'testimonial-slider__prev',
                classNameNextCtrl: 'testimonial-slider__next'
            });

            function autoNextSlide() {
                testimonialSlider.next();

                var currentSlide = testimonialSlider.returnIndex();

                $s.find('.testimonial-slider__dot').each(function(index, ele){

                    var $dot = jQuery(ele);

                    if(currentSlide == $dot.data('slide'))
                        $dot.addClass('testimonial-slider__dot--active');

                });
            }

            var timer;
            function runTimer(run) {
                if (run) {
                    timer = setInterval(function() {
                    autoNextSlide();

                    }, interval);
                } else {
                    clearInterval(timer);
                }
            }

            runTimer(false); // WCAG-53 | toggle auto slider on/off

            jQuery.each([jQuery('.testimonial-slider__prev'), jQuery('.testimonial-slider__next')], function(index, item) {
                var $item = jQuery(item);


                $item.on('click', function() {
                    var currentSlide = testimonialSlider.returnIndex();

                    $s.find('.testimonial-slider__dot').each(function(index, ele){

                        var $dot = jQuery(ele);

                        if(currentSlide == $dot.data('slide'))
                            $dot.addClass('testimonial-slider__dot--active');

                    });

                    runTimer(false);
                    runTimer(false); // WCAG-53 | toggle auto slider on/off
                });
            });

            jQuery(ele).on('click', '.testimonial-slider__dot', function(e){

                testimonialSlider.slideTo(jQuery(this).data('slide'));

                runTimer(false);
                runTimer(false); // WCAG-53 | toggle auto slider on/off

                $s.find('.testimonial-slider__dot').removeClass('testimonial-slider__dot--active');
                jQuery(this).addClass('testimonial-slider__dot--active');

                testimonialSliderAriaHidden();
                testimonialSliderAriaSelectedDots();
                return false;
            });

            ele.addEventListener('after.lory.slide', handleTestimonialDotEvent);
        });
    }

    // * WCAG-53 AODA fixes
    var testimonialSlides = document.getElementsByClassName("testimonial-slider__slide");
    var testimonialSlidesArrows = document.getElementsByClassName("testimonial-slider__arrow");
    var testimonialSlidesDots = document.getElementsByClassName("testimonial-slider__dot");

    function postInitializeTestimonialSlider() {

        for (var index = 0; index < testimonialSlidesArrows.length; index++) {
            var testimonialSlideArrows = testimonialSlidesArrows[index];

            testimonialSlideArrows.onclick = function () {
                testimonialSliderAriaHidden();
                testimonialSliderAriaSelectedDots();
            };
        };

        testimonialSliderAriaHidden();
        testimonialSliderAriaSelectedDots();
    }

    if (jQuery('.testimonial-slider__container').length) {
        initializeTestimonialSlider();
        postInitializeTestimonialSlider();
    }
    // * end WCAG-53 AODA fixes


    // FIX for slider in PJAX container
    jQuery(document).on('ready pjax:success', function() {
        if (jQuery('.testimonial-slider__container').length) {
            initializeTestimonialSlider();
            postInitializeTestimonialSlider();
        }
    });

});

//------ TESTIMONIAL SLIDER ENDS ------//